import { apiClient } from '../../gateways/api'
import type { FetchAansluitingValuelists } from '../types/FetchAansluitingValuelists'

export { fetchAansluitingValuelists, initialState }

const initialState: FetchAansluitingValuelists = {
  data: {
    combis: [],
    gebieden: [],
    labels: [],
    netbeheerders: [],
    uitvoerendeAannemers: [],
    coordinerendeAannemers: [],
    actiehouders: [],
  },
}

const fetchAansluitingValuelists = async (): Promise<
  FetchAansluitingValuelists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/aansluiting/lists/organisation',
    method: 'GET',
  })
  return data
}
